import { WebRoutes } from "consts/enpoints/web";
import type { HighRiskMerchant as HighRiskMerchantType } from "features/ecommerce/types";
import { useOnboardingComplete } from "ui/organizms/ECommerce/Onboarding/common";
import { useOnboardingApplication } from "../../hooks";

export const useComplete = () => {
    const { getApplicationModel } = useOnboardingApplication();

    return useOnboardingComplete<HighRiskMerchantType.OnboardingApplication>({
        route: WebRoutes.Onboarding.HighRiskMerchant,
        getApplicationModel
    });
};

export default useComplete;
